import React from 'react';
import { Card } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';

const FeatureCard = ({ roles, currentUserRole, Icon, title, link }) => {
    if (!roles?.includes(currentUserRole)) {
        return null;
    }

    return (
        <Card clickable className="feature-card">
            <Card.Content>
                <Card.Heading className="nhsuk-heading-m feature-card__heading">
                    <div className="feature-card__icon">
                        {Icon && <Icon />}
                    </div>
                    <Link to={link}>{title}</Link>
                </Card.Heading>
            </Card.Content>
        </Card>
    );
};

export default FeatureCard;
